import React, { Component } from "react";
import "./App.css";
import Typography from "@material-ui/core/Typography/Typography";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import MainContainer from "./Features/MainContainer";

const styles = {
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  },
  button: {
    marginLeft: 20
  },
  appBar: {
    backgroundColor: "#071F2B"
  }
};

class App extends Component {
  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
  }

  render() {
    const { classes } = this.props;
    const { isAuthenticated } = this.props.auth;

    return (
      <div className={classes.root}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              Delta Agent Intro Recorder
            </Typography>
            {!isAuthenticated() && (
              <Button
                variant="contained"
                onClick={this.login.bind(this)}
                className={classes.button}
              >
                Log In
              </Button>
            )}
            {isAuthenticated() && (
              <Button
                variant="contained"
                color="secondary"
                onClick={this.logout.bind(this)}
                className={classes.button}
              >
                Log Out
              </Button>
            )}
          </Toolbar>
        </AppBar>
        <div>{isAuthenticated() && <MainContainer />}</div>
      </div>
    );
  }
}

export default withStyles(styles)(App);
